import React, { useEffect } from "react";
import BottomNav from "../common/BottomNav";
import ConnectionBanner from "../common/ConnectionBanner";
import OutboxBanner from "../common/OutboxBanner";
import outbox from "../../services/attendanceOutbox";
import { useAuth } from "../../context/AuthContext";

export default function AppLayout({ children }) {
  const { offline } = useAuth();
  // Aktifkan pengiriman ulang antrean absen (online / fokus / app dibuka lagi).
  // Idempoten — aman dipanggil dari tiap halaman.
  useEffect(() => { outbox.start(); }, []);

  return (
    <div className="relative min-h-dvh bg-surface">
      <ConnectionBanner />
      {offline && (
        <div className="border-b border-slate-200 bg-slate-100 px-3.5 py-2 text-slate-700">
          <p className="mx-auto max-w-[430px] text-[11px] font-semibold leading-snug">
            <span className="font-black uppercase tracking-wider">Mode offline</span> · Kamu tetap bisa absen. Data
            disimpan di HP dan dikirim otomatis saat server kembali online.
          </p>
        </div>
      )}
      <OutboxBanner />
      <main className="page-content">{children}</main>
      <BottomNav />
    </div>
  );
}
